import React, { useRef } from 'react';

import { cssMap } from '@atlaskit/css';
// Per-component subpath: the `@atlaskit/primitives/compiled` barrel is a fully
// deprecated entry point and new imports from it fail the ratcheting check.
import { Inline } from '@atlaskit/primitives/compiled/inline';

import { useWidthObserverRegistration } from '../../../../common/ui/width-observer';
import { Apps } from './apps';
import { FiltersControl } from './filters-control';
import { InlineFilters } from './inline-filters';
import { MoreApps } from './more-apps';
import { REFRESH_FILTER_ROW_APPS_WIDTH_ID, REFRESH_FILTER_ROW_WIDTH_ID } from './row-width';

const styles = cssMap({
	row: {
		// Inline's xcss type rejects space tokens for minHeight; 32px === space.400.
		minHeight: '32px',
	},
	// Keeps the measured app width independent of how many filters render, so
	// reflowing them cannot feed back into the measurement.
	appsGroup: {
		flexShrink: 0,
	},
});

export const RefreshFilterRow = (): React.JSX.Element => {
	const rowRef = useRef<HTMLDivElement>(null);
	const appsRef = useRef<HTMLDivElement>(null);

	useWidthObserverRegistration(REFRESH_FILTER_ROW_WIDTH_ID, rowRef);
	useWidthObserverRegistration(REFRESH_FILTER_ROW_APPS_WIDTH_ID, appsRef);

	return (
		<Inline
			ref={rowRef}
			spread="space-between"
			alignBlock="center"
			xcss={styles.row}
			testId="search-page-refresh-filter-row"
		>
			<Inline ref={appsRef} space="space.075" alignBlock="center" xcss={styles.appsGroup}>
				<Apps />
				<MoreApps />
			</Inline>
			<Inline space="space.050" alignBlock="center">
				<InlineFilters />
				<FiltersControl />
			</Inline>
		</Inline>
	);
};
